import React from "react";
import styles from "./metric.module.css";

const colors = ["#070707", "#0F3F73", "#5B2C6F", "#730F6C", '#66730F', "#1F946D"]; // Backgrounds for clicked boxes

const Metric = ({ data = [], selectedMetrics = [], onMetricClick = () => {} }) => {

  return data?.map((e, i) => {
    const isSelected = selectedMetrics.includes(e.key);
    const bgColor = isSelected ? colors[i % colors.length] : "#fff";
    const textColor = isSelected ? "#fff" : "#000";

    return (
      <div
        key={i}
        className={styles.Metrics}
        onClick={() => onMetricClick(e.key)}
        style={{ 
          backgroundColor: bgColor,
          cursor: 'pointer',
          border: isSelected ? '2px solid rgba(255,255,255,0.3)' : '1px solid #e0e0e0'
        }}
      >
        <div className={styles.label} style={{ color: textColor }}>
          {e?.label}
        </div>
        <div className={styles.Info}>
          <span className={styles.metric} style={{ color: textColor }}>
           {e?.metric}
          </span>
          <img
            src={`/icons/${e?.icon}.svg`}
            alt={`Metric icon for ${e?.label}`}
            className={styles.icon}
            style={{ 
              filter: isSelected ? 'brightness(0) invert(1)' : 'none'
            }}
          />
        </div>
      </div>
    );
  });
};

export default Metric;